'use strict';

exports.__esModule = true;
var isWebColor = function isWebColor(color) {
  return color === 'currentcolor' || color === 'currentColor' || color === 'inherit' || color.indexOf('var(') === 0;
};

exports.default = isWebColor;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-native-web/dist/cjs/modules/isWebColor/index.js
// module id = 1450
// module chunks = 0